(function () {
  class AnticipationAnalysisScatter {
    constructor() {
      this._symbolData = [];
    }

    // data is an array of symbols to reels that they can be collected on, and how many are needed
    // [ {symId:9, num:3, reels [0,2,4]}] // 3 of a kind scatters that appear on 1 3 and 5 only
    // [ {symId:9, num:3, reels [0,2,4]}, {symId: 10, num: 3, reels:[0,1,2,3,4]}], multiple bonus symbols, symId 9 only on reels 1,3 and 5. SymId 10 on all reels
    initialise(data) {
      this._symbolData = data;
    }

    analyseSpinData(symbols) {
      let res = [];

      for (let i = 0; i < this._symbolData.length; ++i) {
        let symData = this._symbolData[i];
        let scatterCount = 0;
        let found = false;
        let triggerdReelId = -1;
        for (let reel = 0; reel < symbols.length && !found; ++reel) {
          for (let row = 0; row < symbols[reel].length; ++row) {
            if (symbols[reel][row] === symData.symId) {
              ++scatterCount;
              if (scatterCount === symData.num - 1) {
                found = true;
                triggerdReelId = reel;
                break;
              }
            }
          }
        }

        if (found) {
          let triggeredReelIdx = symData.reels.indexOf(triggerdReelId);
          let reelsToAnticipate = symData.reels.slice(triggeredReelIdx + 1);
          res.push({
            symId: symData.symId,
            anticipationReels: reelsToAnticipate,
          });
        }
      }
      return res;
    }
  }

  let create = function () {
    return new AnticipationAnalysisScatter();
  };

  resourceManager.registerSharedPlugin("AnticipationAnalysisScatter", create);
})();
